<template>
  <FlexTable class="indications-table">
    <transition-group name="indications-transition">
      <div
        class="flex-trow"
        v-for="(indication, index) in dataIndications"
        :key="'indication-'+index"
      >
        <div class="remove-indication" @click="removeElement(index)">x</div>
        <div class="flex-td editable-cell">
          <EditableCellInput v-model="indication.text" :is-textarea="true" :autoselect="false" />
        </div>
      </div>
    </transition-group>
  </FlexTable>
</template>

<script>
import DragTable from "./base/DragTable";
import EditableCellInput from "../EditableCellInput";
import FlexTable from "./base/FlexTable";

export default {
  name: "IndicationsTable",
  components: { FlexTable, EditableCellInput, DragTable },
  model: {
    prop: "indications",
    event: "change"
  },
  props: {
    title: {
      type: String,
      default: "Importante"
    },
    indications: {
      type: Array,
      default: function() {
        return [];
      }
    }
  },
  methods: {
    removeElement: function(index) {
      this.dataIndications.splice(index, 1);
    }
  },
  watch: {
    dataIndications: function(val) {
      this.$emit("change", val);
    },
    indications: function(val) {
      this.dataIndications = val;
    }
  },
  data: function() {
    return {
      dataIndications: this.indications
    };
  }
};
</script>

<style scoped lang="scss">
.indications-table {
  overflow-x: auto;
  overflow-y: hidden;
  padding: 4px;
  width: 100%;

  & span {
    width: 100%;
  }
}

.table-title {
  color: $white;
  background-color: $gray-600;
}

.flex-trow {
  position: relative;
  border-left: 1px solid $gray-500;
  border-right: 1px solid $gray-500;
  border-bottom: 1px solid $gray-300;

  &:first-child {
    border-top: 1px solid $gray-500;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
  }

  &:last-child {
    border-bottom: 1px solid $gray-500;
    border-bottom-left-radius: 10px;
    border-bottom-right-radius: 10px;
  }

  & .remove-indication {
    display: none;
    position: absolute;
    margin: -0.5px;
    height: 100%;
    align-items: center;
    width: 32px;
    justify-content: center;
    color: black;
    background-color: rgba(grey, 0.1);
  }

  &:hover .remove-indication {
    display: flex;
    cursor: pointer;
  }

  &:first-child .remove-indication {
    border-top-left-radius: 10px;
  }

  &:last-child .remove-indication {
    border-bottom-left-radius: 10px;
  }
}

.flex-td {
  justify-content: flex-start;
  text-align: left;
  border: none;

  & input {
    text-align: left;
    padding-left: 40px;
  }

  & textarea {
    text-align: left;
    padding-left: 40px;
  }
}

.indications-transition-enter-active,
.indications-transition-leave-active {
  transition: opacity 0.2s;
}

.indications-transition-enter,
.indications-transition-leave-to {
  opacity: 0;
}

.indications-transition-leave,
.indications-transition-enter-to {
  opacity: 1;
}
</style>